'use client'

import { forwardRef, useImperativeHandle, useRef } from 'react'
import { Turnstile, type TurnstileInstance } from '@marsidev/react-turnstile'

type Props = {
  onSuccess: (token: string) => void
  onExpire?: () => void
  onError?: () => void
}

export const CaptchaWidget = forwardRef<TurnstileInstance | null, Props>(
  function CaptchaWidget({ onSuccess, onExpire, onError }, ref) {
    const innerRef = useRef<TurnstileInstance | null>(null)
    // forwardRef alone doesn't proxy to a nested ref; we have to re-expose the
    // TurnstileInstance methods so callers can drive reset()/getResponse() from outside.
    useImperativeHandle(ref, () => innerRef.current as TurnstileInstance, [])

    const siteKey = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY
    if (!siteKey) {
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[captcha] NEXT_PUBLIC_TURNSTILE_SITE_KEY not set — widget disabled')
      }
      return null
    }

    return (
      <Turnstile
        ref={innerRef}
        siteKey={siteKey}
        onSuccess={onSuccess}
        onExpire={onExpire}
        onError={onError}
        options={{ theme: 'dark', appearance: 'interaction-only', retry: 'auto', size: 'flexible' }}
      />
    )
  }
)
